import { isMobile } from 'react-device-detect';
import { matchPath, useLocation } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { TOOLKIT_PATH } from '@/components/Dashboard/enums/shared';
import {
  FF_MOBILE_GENERATOR_AND_CATALOG,
  FF_MOBILE_SIGNUP_HANDOFF,
  FF_WEAVE_TOOLS_MOBILE,
} from '@/consts/featureFlags';
import { isMobileSignupHandoffRoute } from '@/consts/mobileHandoff.consts';
import { AuthContext } from '@/contexts/AuthContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { MobileSignupHandoffPage } from './MobileSignupHandoffPage/MobileSignupHandoffPage';
import { MobileUnsupportedPage } from './MobileUnsupportedPage/MobileUnsupportedPage';

const ALLOWED_PATHS = ['/pricing', '/signin'];
/** Excluded only while `FF_MOBILE_GENERATOR_AND_CATALOG` is off. */
const GENERATOR_AND_CATALOG_PATHS = ['/generate', TOOLKIT_PATH];

type WithMobileCheckProps = {
  children: React.JSX.Element;
};

export const MobileCheck = ({ children }: WithMobileCheckProps): React.JSX.Element => {
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  const { value: isMobileSignupHandoffEnabled } = useFeatureFlag(FF_MOBILE_SIGNUP_HANDOFF);
  const { value: isMobileGeneratorAndCatalogEnabled } = useFeatureFlag(FF_MOBILE_GENERATOR_AND_CATALOG);
  const { value: isToolsMobileEnabled } = useFeatureFlag(FF_WEAVE_TOOLS_MOBILE);

  const isPathAllowed =
    ALLOWED_PATHS.includes(location.pathname) ||
    (isMobileGeneratorAndCatalogEnabled === true && GENERATOR_AND_CATALOG_PATHS.includes(location.pathname)) ||
    (isToolsMobileEnabled === true && !!matchPath('/tool/:toolId', location.pathname));
  const shouldShowSignupHandoff = useMemo(() => {
    return Boolean(currentUser) && isMobileSignupHandoffRoute(location.pathname, location.search);
  }, [currentUser, location.pathname, location.search]);

  if (!isPathAllowed && isMobile) {
    if (isMobileSignupHandoffEnabled === true && shouldShowSignupHandoff) {
      return <MobileSignupHandoffPage />;
    }

    return <MobileUnsupportedPage />;
  }

  return children;
};
